import React from 'react';
import PropTypes from 'prop-types';
import NotificationModal from 'bento-ordering/base/components/NotificationModal';
import PrimaryCta from 'components/Buttons/PrimaryCta';
import { fulfillmentOptions } from 'constants/fulfillmentOptions';

class MenuHoursExpiredNotification extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func,
    handlePrimaryCta: PropTypes.func,
    onlineOrderingFulfillmentMethod: PropTypes.oneOf([
      fulfillmentOptions.PICKUP,
      fulfillmentOptions.DELIVERY,
      fulfillmentOptions.DINE_IN
    ])
  };

  getFulfillmentMethodDisplayText() {
    switch (this.props.onlineOrderingFulfillmentMethod) {
      case fulfillmentOptions.PICKUP:
        return 'pickup';
      case fulfillmentOptions.DELIVERY:
        return 'delivery';
      case fulfillmentOptions.DINE_IN:
        return 'dine-in';
      default:
        return '';
    }
  }

  render() {
    const { closeModal, handlePrimaryCta } = this.props;
    return (
      <NotificationModal
        title="Oops! This menu has changed"
        body={`Please set a new time for your ${this.getFulfillmentMethodDisplayText()} order. Be aware that item availability may have changed.`}
        onClose={closeModal}
      >
        <PrimaryCta
          label="Set A New Time"
          handleClick={handlePrimaryCta}
          fullWidth
        />
      </NotificationModal>
    );
  }
}

export default MenuHoursExpiredNotification;
